import { Injectable } from '@angular/core';
import { AbstractCacheService } from './AbstractCacheService';

@Injectable({
    providedIn: 'root'
})
export class LocalStorageService extends AbstractCacheService {
    constructor() {
        super(localStorage);
    }
}
